import React from "react";
import AssetValuationListTables from "./Assets/AssetValuation";

const DataReview = () => (
    <AssetValuationListTables
        showReviewTabs
        showCategoryTabs
        categoryTabs={[
            { label: "Buildings", value: "BLDG" },
            { label: "Furniture & Fittings", value: "FURN" },
            { label: "ICT Equipment", value: "ICT" },
            { label: "Motor Vehicles (incl. Motorcycles)", value: "VEH" },
            { label: "Machinery & Plants", value: "MACH" },
            { label: "Land", value: "LAND" },
            { label: "Equipment (General/Medical/Office)", value: "EQP" },
            { label: "Infrastructure", value: "INFR" },
            { label: "Site Works", value: "SITE" },
        ]}
        defaultReviewTab="unreviewed"
        defaultCategoryTab="BLDG"
        showCategoryStats
        showDateFilters={false}
        showAddButton={false}
        actionMode="edit-only"
        tableMode="assets"
        breadcrumbItem="Data Review"
        cardTitle="Data Review"
    />
);

export default DataReview;
